module.exports = __webpack_public_path__ + "img/banner.6.4c5c4eae.png";